import { DrawerBody, ModalBody } from '@cat-ecom/pcc-components';

type AssociatedDealerBodyProps = {
  isModal: boolean;
  children: React.ReactNode;
};

export const AssociatedDealerBody = ({
  isModal,
  children
}: AssociatedDealerBodyProps) => {
  return (
    <>
      {isModal ? (
        <ModalBody>{children}</ModalBody>
      ) : (
        <DrawerBody>{children}</DrawerBody>
      )}
    </>
  );
};
